/**
 * Resolve the absence/attendance fine from a fines list.
 * Used for attendance flow: marking absent, status change window, fine amount display.
 *
 * Matching order:
 * 1. Category "Attendance" or "Absence" (backend-aligned; editable names won't break lookup)
 * 2. Name contains "attendance" or "absent" (fallback for legacy configs)
 *
 * Only active fines (is_active === 1) are considered.
 *
 * @param {Array} finesList - Raw fines from useGetFinesQuery (may include category relation)
 * @returns {{ amount: number, status_change_window: number }}
 */
export function resolveAbsenceFine(finesList) {
  const defaultResult = { amount: 0, statusChangeWindow: 30 };

  if (!Array.isArray(finesList) || !finesList.length) return defaultResult;

  const activeFines = finesList.filter(
    (f) => f && (f.is_active === 1 || f.is_active === true)
  );

  const match = activeFines.find((f) => {
    const catName = (f.category?.name || f.category_name || "").toLowerCase();
    const name = String(f.name || "").toLowerCase();
    if (["attendance", "absence"].includes(catName)) return true;
    if (name.includes("attendance") || name.includes("absent")) return true;
    return false;
  });

  if (!match) return defaultResult;

  return {
    amount: Number(match.amount) || 0,
    statusChangeWindow: Number(match.status_change_window) || 30,
  };
}
